import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestMethod } from '../classes/RequestMethod';
import { HttpClickHandler } from '../directives/http-click.directive';
import { AuthorizationService } from './authorization.service';
import { Util } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public systemSettings: any;
  tokenOptions: any;

  constructor(private util: Util, private authorizationService: AuthorizationService) {
    this.systemSettings = {};
  }

  generateBlobHttpOptions(): any {
    return {
      headers: new HttpHeaders({ 'Content-type': 'application/json' }),
      responseType: 'blob'
    };
  }

  generateTextHttpOptions(): any {
    return {
      headers: new HttpHeaders({ 'Content-type': 'application/json' }),
      responseType: 'text/plain'
    };
  }

  generateCustomTokenHttpOptions(): any {
    const token = this.authorizationService.getToken();

    let options = {
      headers: new HttpHeaders({ 'Content-type': 'application/json' }),
    };
    if (token) {
      options.headers = options.headers.append('Authorization', 'Bearer ' + token);
    }
    return options;
  }

  generateCustomTokenHttpOptionsForViewer(): any {
    let options = {
      headers: new HttpHeaders({ 'Content-type': 'application/json; charset=UTF-8' }),
    };
    return options;
  }

  getUserPage(data: any, httpClickHandler?: HttpClickHandler): Observable<any> {
    return this.util.createApi("Users/getUsersBlocked", JSON.stringify(data), httpClickHandler, RequestMethod.POST);
  }

  goToViewer(data: any, httClickHandler?: HttpClickHandler): Observable<any> {
    return this.util.createSsoApi("login/login", JSON.stringify(data), httClickHandler, RequestMethod.POST);
  }

  addUpdateSettings(data: any, httpClickHandler?: HttpClickHandler): Observable<any> {
    return this.util.createApi("Settings/addUpdateSettings", JSON.stringify(data), httpClickHandler, RequestMethod.POST);
  }

  getSettings(data: any, httpClickHandler?: HttpClickHandler): Observable<any> {
    return this.util.createApi("Settings/getSettings", JSON.stringify(data), httpClickHandler, RequestMethod.POST);
  }

  unBlock(data: any, httpClickHandler?: HttpClickHandler): Observable<any> {
    return this.util.createApi("Users/unBlock", JSON.stringify(data), httpClickHandler, RequestMethod.POST);
  }

  changeUserPassword(data: any, httpClickHandler?: HttpClickHandler): Observable<any> {
    return this.util.createApi("Users/changePassword", JSON.stringify(data), httpClickHandler, RequestMethod.POST);
  }
}
